// environment.qa.ts
export const environment = {
    production: false,
    NX_API_URL: 'https://nscn6gytjyp6pbbzvdxztm2hyi0iijxd.lambda-url.us-east-1.on.aws/graphql',
    NX_API_KEY: 'yMmWgk2xUVaQC8pS56U9b5MjFZ3Z0MB41aut8Yf9',
    NX_API_URL_DS: 'https://j34o6wnkv3umi2nzzuw3klpdiq0emosx.lambda-url.us-east-1.on.aws/graphql',
    NX_API_KEY_DS: 'dpcVEmFJXt9IA0oqmsHAC4LiEYa95drEsdP4WZs2',
    NX_API_URL_CORE: 'https://zhb7byguie773bpanr54u7bsky0ppwaz.lambda-url.us-east-1.on.aws/graphql',
    NX_API_KEY_CORE: 'JmhAailyrg6YUQIJN24fK4BPXOaec5Qs40o6gV38',
    GLP_REDIRECTION_URL: 'http://planning.uat.guideline.ai'
};
